import { render, staticRenderFns } from "./attr-block.vue?vue&type=template&id=cd1c666a"
import script from "./attr-block.vue?vue&type=script&lang=js"
export * from "./attr-block.vue?vue&type=script&lang=js"
import style0 from "./attr-block.vue?vue&type=style&index=0&id=cd1c666a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports